import { defineComponent as _defineComponent } from 'vue'
import LoginSideMenuContents from './components/LoginSideMenuContents.vue';
import RewardsSideMenuContents from '../rewards-sign-up/components/RewardsSideMenuContents.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import SideMenuHeaderButton from '../SideMenuHeaderButton.vue';
import Spinner from 'JS/components/Spinner.vue';
import { checkWebpFeature } from 'JS/global/images';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { IJoinRewardsStep } from 'JS/types/rewards';
import { LoginPages, LoginPageType } from 'JS/types/Account';
import { provideServices } from '../composables/services';



export default /*#__PURE__*/_defineComponent({
  __name: 'LoginSideMenu',
  props: {
	show: {
		type: Boolean
	},
	page: {
		type: String as PropType<LoginPageType>,
		default: "login",
		required: false
	},
	skipCartMerge: {
		type: Boolean,
		default: false,
		required: false,
	},
	destinationUrl: {
		type: String,
		default: null,
		required: false,
	},
	fromRewards: {
		type: Boolean,
		default: false,
		required: false,
	}
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
	(event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

//Imports




provideServices();

const currentPage = ref<LoginPageType>(null);
const joinRewardsStep = ref<IJoinRewardsStep>(null);
const forceReload = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const pageHistory = ref<Array<IJoinRewardsStep | LoginPageType>>([]);

const showBackArrow = computed((): boolean => {
	return pageHistory.value.length != 0;
});

function updateSideMenuHeaderButton(prevPage: IJoinRewardsStep | LoginPageType | "clear") {
	if (prevPage === 'clear') {
		pageHistory.value = [];
	} else {
		pageHistory.value.push(prevPage);
	}
}

function handleBackArrow() {
	const page = pageHistory.value.pop();
	if (isLoginPage(page)) {
		currentPage.value = page as LoginPageType;
	} else {
		joinRewardsStep.value = page as IJoinRewardsStep;
	}
}

function isLoginPage(value: string): boolean {
	return LoginPages.hasOwnProperty(value);
}

function determineClose() {
	if (forceReload.value) props.destinationUrl ? window.location.href = props.destinationUrl : window.location.reload();
	emit('close');
}

function handleIsLoading(value: boolean) {
	isLoading.value = value;
}

function handleSignedIn(isRewardsMember: boolean) {
	forceReload.value = true;
	if (props.fromRewards && !isRewardsMember) {
		handleGoToRewards();
	} else {
		determineClose();
	}
}

function handleGoToRewards() {
	forceReload.value = true;
	joinRewardsStep.value = 'join';
}

function reset() {
	pageHistory.value = [];
	currentPage.value = props.page;
}

watch(() => props.page, (newPage) => {
	currentPage.value = newPage;
}, { immediate: true });

//Adds this image to the cache so it's pre-loaded before sidepanel opening.
function preloadImages() {
	checkWebpFeature("alpha").then(isSupported => {
		if (isSupported) {
			new Image().src = "/assets/images/rewards/rewards-header-mobile.webp";
			new Image().src = "/assets/images/forgot-password/check-mail-icon.webp";
			new Image().src = "/assets/images/forgot-password/send-mail-icon.webp";
		} else {
			new Image().src = "/assets/images/rewards/rewards-header-mobile.png";
			new Image().src = "/assets/images/forgot-password/check-mail-icon.png";
			new Image().src = "/assets/images/forgot-password/send-mail-icon.png";
		}
	});
}

onMounted(()=> {
	preloadImages();;
});


return { __sfc: true,props, emit, currentPage, joinRewardsStep, forceReload, isLoading, pageHistory, showBackArrow, updateSideMenuHeaderButton, handleBackArrow, isLoginPage, determineClose, handleIsLoading, handleSignedIn, handleGoToRewards, reset, preloadImages, LoginSideMenuContents, RewardsSideMenuContents, SideMenu, SideMenuHeaderButton, Spinner }
}

})